/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import HeaderPresenter from './HeaderPresenter';
import DTOHeader from './DTOHeader';
import { useTranslation } from 'react-i18next';
import { changeApplang } from '../../configs/utils';
import '././../../themes/i18n';
import { personalInfoType } from '../../interfaces/myProfile/personalDetails/personalInfo';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import { dashboardService } from '../../../api/services/dashboardService';
import AuthInterface from '../../../infra/aggregates/AuthInterface';
import { user_login } from '../../../infra/aggregates/authSlice';
import { personalInfoReducer } from '../../../infra/aggregates/myProfile/personalInfoSlice';
import { setLangLoader } from '../../../infra/aggregates/LoaderSlice';

function HeaderController() {
  const { t, i18n } = useTranslation();
  const selector = useAppSelector((state) => state);

  const [headerData, setHeaderData] = useState({});

  function callback(data: object) {
    setHeaderData(data);
  }

  const changeLang = () => {
    dispatch(setLangLoader(true));
    const newlang = i18n.language == 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newlang);
    changeApplang(newlang, false);
    refresh_LangData();
  };

  const dispatch = useAppDispatch();
  let personal_Info_data: personalInfoType = {
    firstName: '',
    lastName: '',
    DOB: new Date(),
    gender: '',
    martialStatus: '',
    country: '',
    email: '',
    phone: '',
    countryId: 0,
    genderId: 0,
    maritalStatusId: 0,
    education: '',
    religious: '',
    nationalityId: 0,
    nationalityName: '',
  };

  const refresh_LangData = async () => {
    const employeeId = selector.authSlice.emp_id;
    const response = await dashboardService.getdashboardService(employeeId);
    if (response) {
      const { get_emp_details }: any = response;

      const user_obj: AuthInterface = {
        user_id: get_emp_details?.user?.id,
        name: get_emp_details?.first_name,
        username: get_emp_details?.user?.username,
        currency: selector.authSlice.currency,
        email: get_emp_details?.user?.email,
        status: get_emp_details?.status,
        profile_pic: selector.authSlice.profile_pic,
        company_id: get_emp_details.company_id,
        designaion: get_emp_details?.emp_job_detail?.designation?.name,
        department: get_emp_details?.emp_job_detail?.department?.name,
        emp_id: get_emp_details.emp_job_detail?.emp_id,
        department_id: get_emp_details?.emp_job_detail?.department?.id,
        staff_id: get_emp_details?.staff_id,
        hire_date: get_emp_details?.emp_job_detail?.hire_date,
      };

      personal_Info_data = {
        firstName: get_emp_details.first_name,
        lastName: get_emp_details.last_name,
        DOB: get_emp_details.dob,
        gender: get_emp_details?.gender_name?.name,
        genderId: get_emp_details?.gender_name?.id,
        martialStatus: get_emp_details?.marital_status?.name,
        maritalStatusId: get_emp_details?.marital_status?.id,
        country: get_emp_details?.country?.name,
        countryId: get_emp_details?.country?.id,
        email: get_emp_details?.email,
        phone: get_emp_details?.phone,
        education: get_emp_details?.education,
        religious: get_emp_details?.religious,
        nationalityId: get_emp_details?.country_of_birth?.id,
        nationalityName: get_emp_details?.country_of_birth?.name,
      };
      dispatch(personalInfoReducer(personal_Info_data));

      dispatch(user_login(user_obj));
      dispatch(setLangLoader(false));
    } else {
      dispatch(setLangLoader(false));
    }
  };
  return (
    <div>
      <DTOHeader setHeaderData={callback} />
      <HeaderPresenter
        data={headerData}
        i18n={i18n}
        trans={t}
        changeLang={changeLang}
      />
    </div>
  );
}

export default HeaderController;
